"use client";

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { CashByTeam } from "@/services/dashboardService";
import { formatCurrency } from "@/lib/utils";
import { Wallet, User } from "lucide-react";

interface CashByTeamCardProps {
  data: CashByTeam[];
  loading: boolean;
}

export function CashByTeamCard({ data, loading }: CashByTeamCardProps) {
  if (loading) {
    return (
      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-base font-medium flex items-center gap-2">
            <Wallet className="h-5 w-5" />
            Today's Cash by Team
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-center py-4 text-muted-foreground">Loading...</div>
        </CardContent>
      </Card>
    );
  }

  const totalCash = data.reduce((sum, item) => sum + item.amount, 0);
  const totalOrders = data.reduce((sum, item) => sum + item.orders, 0);

  return (
    <Card>
      <CardHeader className="pb-2">
        <div className="flex items-center justify-between">
          <CardTitle className="text-base font-medium flex items-center gap-2">
            <Wallet className="h-5 w-5" />
            Today's Cash by Team
          </CardTitle>
          <div className="text-right">
            <div className="text-2xl font-bold text-green-600">{formatCurrency(totalCash)}</div>
            <div className="text-xs text-muted-foreground">{totalOrders} orders</div>
          </div>
        </div>
      </CardHeader>
      <CardContent>
        {data.length === 0 ? (
          <div className="text-center py-4 text-muted-foreground">
            No cash collected today
          </div>
        ) : (
          <div className="space-y-3">
            {data.map((item) => (
              <div
                key={item.staffId}
                className="flex items-center justify-between p-3 bg-muted/50 rounded-lg"
              >
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center">
                    <User className="h-4 w-4 text-primary" />
                  </div>
                  <div>
                    <div className="font-medium">{item.staffName}</div>
                    <div className="text-xs text-muted-foreground">{item.orders} orders</div>
                  </div>
                </div>
                <div className="text-lg font-bold text-green-600">
                  {formatCurrency(item.amount)}
                </div>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
